import { render, staticRenderFns } from "./DisputeWithVoiceForm.vue?vue&type=template&id=f5571dd4"
import script from "./DisputeWithVoiceForm.vue?vue&type=script&lang=js"
export * from "./DisputeWithVoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports